import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import ReactDOM from "react-dom";
import "./styles/index.scss";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { Provider } from "react-redux";
import { applyMiddleware, createStore, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import createRootReducer from "./store/root_reducer";
import loggerMiddleware from "./middleware/logger";
import { composeWithDevTools } from "redux-devtools-extension";
import throttle from "lodash.throttle";
import { createBrowserHistory } from "history";
import { routerMiddleware, ConnectedRouter } from "connected-react-router";

import { loadTranslations, setLocale, syncTranslationWithStore } from "react-redux-i18n";
import translations from "./locale";

import { Route, Redirect } from "react-router-dom";
import { navigate } from "./store/navigation/operations";
import NotificationToaster from "./containers/NotificationsToaster";
import SetLanguage from "./components/LanguageSelector/SetLanguage";
import Home from "./pages/Home";
import HomeCoowning from "./pages/HomeCoowning";
import WhyCoOwn from "./pages/WhyCoOwn";
import AboutUs from "./pages/AboutUs";
import HowItWorks from "./pages/HowItWorks";
import Suggestion from "./pages/Suggestion";
import Collection from "./pages/Collection";
import Circle from "./pages/Circle";
import Login from "./containers/auth/Login";
import Register from "./containers/auth/Register";
import "./App.css";
import Onboarding from "./pages/Onboarding";
import MyAccount from "./pages/MyAccount";
import Dashboard from "./pages/Dashboard";
import CircleAdmin from "./pages/CircleAdmin";
import Notifications from "./pages/Notifications";
import Messages from "./pages/Messages";
import MessageDetails from "./pages/MessageDetails";
import CustomIcons from "./pages/CustomIcons";
import CircleEdit from "./pages/CircleEdit";
import ResetPassword from "./containers/auth/ResetPassword";
import RecoverPassword from "./containers/auth/RecoverPassword";
import ActivateAccount from "./containers/auth/ActivateAccount";
import NewCircle from "./pages/NewCircle";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import NewCircleFromSuggestion from "./pages/NewCircleFromSuggestion";
import PublicProfile from "./pages/PublicProfile";
import NewConversation from "./pages/NewConversation";
import CookieBanner from "./containers/CookieBanner";
import IntercomBubble from "./containers/IntercomBubble";
import HomeWithCustomBanner from "./pages/HomeWithCustomBanner";
import WhiteMonday from "./pages/WhiteMonday";
import SharingBox from "./pages/SharingBox";
import ExternalRedirect from "./components/ExternalRedirect";
import PrypoolProducts from "./pages/PrypoolProducts";
import PrypoolSuccessPage from "./pages/PrypoolSuccessPage";
import PurchasePackage from "./pages/PurchasePackage";
import Rentals from "./pages/Rentals";
import RentalsCheckout from "./pages/RentalsCheckout";
import ProductRent from "./pages/ProductRent";
import RentalSuccess from "./pages/RentalSuccess";
import ExternalRentalSuccess from "./pages/ExternalRentalSuccess";
import FullStory from "react-fullstory";
import { hotjar } from "react-hotjar";
import { ENV } from "./config";

const FS_ORG_ID = "QYBA4";

if (ENV === "prod") {
  hotjar.initialize(1291872, 6);
}
export const history = createBrowserHistory();

ReactGA.initialize("UA-137972873-1");

const middlewareEnhancer = applyMiddleware(loggerMiddleware, thunkMiddleware, routerMiddleware(history));
const composedEnhancers = compose(middlewareEnhancer);
const enhancers = composeWithDevTools(composedEnhancers);
const store = createStore(createRootReducer(history), enhancers);
syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale("sv"));
history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

store.subscribe(
  throttle(() => {
    const { accessToken, refreshToken } = store.getState().iam;
    localStorage.setItem("iam", JSON.stringify({ accessToken, refreshToken }));
  }, 1000)
);

const AppShell = () => {
  const [showIntercom, setIntercom] = useState(true);
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
    const state = store.getState();
    const pathname = state.router.location.pathname;
    const exceptions = ['purchase', 'rent-circle', 'rentals'];
    const found_exception = exceptions.find((exception) => pathname.includes(exception));
    if (found_exception) {
      setIntercom(false);
    }
  }, []);

  return (
    <Provider store={store}>
      <FullStory org={FS_ORG_ID} />

      <ConnectedRouter history={history}>
        {showIntercom && <IntercomBubble />}
        {showIntercom && <CookieBanner />}
        <ScrollToTop>
          <Route component={SetLanguage} path="/:lng(en|sv|de)?" />
          <Route component={NotificationToaster} path="/:lng(en|sv|de)?" />
          <Route exact component={Home} path="/:lng(en|sv|de)?">
            {/* <Redirect to="/login" /> */}
            {/* <ExternalRedirect to="https://go.ihopa.com/grannbox" statusCode="307" /> */}
          </Route>
          <Route exact component={HomeCoowning} path="/:lng(en|sv|de)?/agodela" />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="kopbat" />}
            path="/:lng(en|sv|de)?/kopbat"
          />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="saljbaten" />}
            path="/:lng(en|sv|de)?/saljbaten"
          />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="andelsbat" />}
            path="/:lng(en|sv|de)?/andelsbat"
          />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="tradgardsredskap" />}
            path="/:lng(en|sv|de)?/tradgardsredskap"
          />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="automower" />}
            path="/:lng(en|sv|de)?/automower"
          />
          <Route
            render={(routeProps) => <HomeWithCustomBanner {...routeProps} custom_page="fritid" />}
            path="/:lng(en|sv|de)?/fritid"
          />
          <Route component={WhyCoOwn} path="/:lng(en|sv|de)?/why-co-own" />
          <Route component={AboutUs} path="/:lng(en|sv|de)?/about-us" />
          <Route component={HowItWorks} path="/:lng(en|sv|de)?/how-it-works" />
          <Route
            component={Suggestion}
            path="/:lng(en|sv|de)?/suggestion/:collectionId/:suggestionName/:suggestionId"
          />
          <Route component={Collection} path="/:lng(en|sv|de)?/collection/:collectionId" />
          {/* <Route path="/:lng(en|sv|de)?/collection/husqvarna" render={(params) => (<Redirect to={`/${params.match.params.lng}/husqvarna`} />) } /> */}
          <Route component={Circle} path="/:lng(en|sv|de)?/circle/:circleId/:circleCollection?" />
          <Route component={ProductRent} path="/:lng(en|sv|de)?/rent-circle/:circleId" />
          <Route component={RecoverPassword} path="/:lng(en|sv|de)?/recover-password" />
          <Route component={ResetPassword} path="/:lng(en|sv|de)?/reset-password/:token" />
          <Route component={ActivateAccount} path="/:lng(en|sv|de)?/activate-account/:token" />
          <Route
            render={(routeProps) => (
              <Login
                isOpen={true}
                onClose={(_) => {
                  store.dispatch(navigate("/"));
                }}
                redirectTo="/dashboard"
              />
            )}
            path="/:lng(en|sv|de)?/login"
          />
          <Route
            render={(routeProps) => (
              <Register
                isOpen={true}
                onClose={(_) => {
                  store.dispatch(navigate("/"));
                }}
                redirectTo="/dashboard"
              />
            )}
            path="/:lng(en|sv|de)?/sign-up"
          />
          <Route component={Onboarding} path="/:lng(en|sv|de)?/onboarding/:circleId?" />
          <Route component={MyAccount} path="/:lng(en|sv|de)?/my-account" />
          <Route component={Dashboard} path="/:lng(en|sv|de)?/dashboard" />
          <Route exact component={CircleAdmin} path="/:lng(en|sv|de)?/circle-toolbox/:circleId" />
          <Route exact component={CircleEdit} path="/:lng(en|sv|de)?/circle-toolbox/:circleId/edit" />
          <Route component={Notifications} path="/:lng(en|sv|de)?/notifications" />
          <Route component={Messages} exact path="/:lng(en|sv|de)?/messages" />
          <Route component={MessageDetails} exact path="/:lng(en|sv|de)?/messages/:conversationGuid" />
          <Route component={NewConversation} exact path="/:lng(en|sv|de)?/messages/new/:receiverGuid" />
          <Route component={CustomIcons} path="/:lng(en|sv|de)?/custom-icons" />
          <Route exact component={NewCircle} path="/:lng(en|sv|de)?/new-circle" />
          <Route
            exact
            component={NewCircleFromSuggestion}
            path="/:lng(en|sv|de)?/new-circle/:collectionId/:suggestionId"
          />
          <Route component={TermsOfUse} path="/:lng(en|sv|de)?/terms-of-use" />
          <Route component={PrivacyPolicy} path="/:lng(en|sv|de)?/privacy-policy" />
          <Route component={PublicProfile} path="/:lng(en|sv|de)?/public-profile/:userId" />
          <Route component={WhiteMonday} path="/:lng(en|sv|de)?/jul" />
          <Route path="/:lng(en|sv|de)?/whitemonday">
            <Redirect to="/jul" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/grannskap">
            <ExternalRedirect to="https://blog.ihopa.com/grannskap" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/press">
            <ExternalRedirect to="https://go.ihopa.com/press/" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/delningsbox">
            <ExternalRedirect to="https://blog.ihopa.com/husqvarna-delningsbox/" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/prylpool">
            <ExternalRedirect to="https://blog.ihopa.com/prylpool" statusCode="301" />
          </Route>

          <Route path="/:lng(en|sv|de)?/grannbox">
            <ExternalRedirect to="https://go.ihopa.com/grannbox" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/husqvarna">
            <ExternalRedirect to="https://go.ihopa.com/grannbox" statusCode="301" />
          </Route>

          <Route path="/:lng(en|sv|de)?/enskedefaltet">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/enskedefaltet" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/tranholmen">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/tranholmen" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/sodraangby">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/sodraangby" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/tornskogen">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/tornskogen" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/solgard">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/solgard" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/mortnas">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/mortnas" statusCode="301" />
          </Route>
          <Route path="/:lng(en|sv|de)?/alsten">
            <ExternalRedirect to="https://go.ihopa.com/grannbox/alsten" statusCode="301" />
          </Route>

          <Route component={SharingBox} path="/:lng(en|sv|de)?/sharing-box/:boxId" />
          <Route component={PurchasePackage} path="/:lng(en|sv|de)?/purchase" />
          <Route component={Rentals} path="/:lng(en|sv|de)?/rentals" />
          <Route component={RentalsCheckout} path="/:lng(en|sv|de)?/rentals-checkout" />
          <Route component={RentalSuccess} path="/:lng(en|sv|de)?/rental-success" />
          <Route component={ExternalRentalSuccess} path="/:lng(en|sv|de)?/external-rental-success" />
          <Route component={PrypoolProducts} path="/:lng(en|sv|de)?/prypool-onboard/:poolId" />
          <Route component={PrypoolSuccessPage} path="/:lng(en|sv|de)?/sharing-box-success/:poolId" />
        </ScrollToTop>
      </ConnectedRouter>
    </Provider>
  );
};

ReactDOM.render(<AppShell />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store;
}
